import { createAuditRoutes } from "@template/modules/auditRoutes";

export const protectedRoutes = createAuditRoutes();
